"use client";
import { useCompositeStoreOptions, useCompositeStoreProps } from "../composite/composite-store.js";
import { usePopoverStoreProps } from "../popover/popover-store.js";
import { useTagContext } from "../tag/tag-context.js";
import { useUpdateEffect } from "@ariakit/react-utils";
import { useStore, useStoreProps } from "@ariakit/react-store";
import * as Core from "@ariakit/components/combobox/combobox-store";
//#region src/combobox/combobox-store.ts
function useComboboxStoreOptions(props) {
	const tag = useTagContext();
	props = {
		...props,
		tag: props.tag !== void 0 ? props.tag : tag
	};
	return useCompositeStoreOptions(props);
}
function useComboboxStoreProps(store, update, props) {
	useUpdateEffect(update, [props.tag]);
	useStoreProps(store, props, "value", "setValue");
	useStoreProps(store, props, "selectedValue", "setSelectedValue");
	useStoreProps(store, props, "resetValueOnHide");
	useStoreProps(store, props, "resetValueOnSelect");
	return Object.assign(useCompositeStoreProps(usePopoverStoreProps(store, update, props), update, props), { tag: props.tag });
}
function useComboboxStore(props = {}) {
	props = useComboboxStoreOptions(props);
	const [store, update] = useStore(Core.createComboboxStore, props);
	return useComboboxStoreProps(store, update, props);
}
//#endregion
export { useComboboxStore, useComboboxStoreOptions, useComboboxStoreProps };

//# sourceMappingURL=combobox-store.js.map